/**
 * Shared utilities for product carousel sections.
 * - Mobile image swiper initialization
 * - Recently viewed localStorage management
 */

window.initCarouselSwipers = function (container) {
  if (window.matchMedia('(min-width: 750px)').matches) return;
  if (container.dataset.swipersInitialized === 'true') return;
  container.dataset.swipersInitialized = 'true';

  container.querySelectorAll('.product-carousel__card--has-swiper').forEach(function (card) {
    var template = card.querySelector('.product-carousel__swiper-data');
    if (!template) return;

    var cardMedia = card.querySelector('.card__media');
    if (!cardMedia) return;

    var templateImages = Array.from(template.content.querySelectorAll('img'));
    if (templateImages.length < 2) return;

    // Use the already-rendered card image as the authoritative first slide,
    // so mobile matches desktop even if the template's ordering differs.
    var primaryImg = card.querySelector('.media.media--hover-effect > img');
    var primarySrc = primaryImg ? (primaryImg.currentSrc || primaryImg.src) : null;
    var primaryKey = primarySrc ? primarySrc.split('?')[0] : null;

    var orderedImages = [];
    if (primaryImg) orderedImages.push(primaryImg.cloneNode(true));
    templateImages.forEach(function (img) {
      var key = (img.src || '').split('?')[0];
      if (primaryKey && key === primaryKey) return;
      orderedImages.push(img.cloneNode(true));
    });

    // Build swiper
    var swiper = document.createElement('div');
    swiper.className = 'product-carousel__swiper';
    orderedImages.forEach(function (img) {
      swiper.appendChild(img);
    });
    var images = orderedImages;

    // Build dots
    var dots = document.createElement('div');
    dots.className = 'product-carousel__dots';
    images.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'product-carousel__dot' + (i === 0 ? ' product-carousel__dot--active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dots.appendChild(dot);
    });

    cardMedia.appendChild(swiper);
    cardMedia.appendChild(dots);

    // Touch handling
    var startX = 0;
    var currentIndex = 0;
    var total = images.length;

    swiper.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      swiper.style.transition = 'none';
    }, { passive: true });

    swiper.addEventListener('touchmove', function (e) {
      var diff = e.touches[0].clientX - startX;
      var offset = -(currentIndex * 100) + (diff / cardMedia.offsetWidth) * 100;
      swiper.style.transform = 'translateX(' + offset + '%)';
    }, { passive: true });

    swiper.addEventListener('touchend', function (e) {
      swiper.style.transition = 'transform 0.3s ease';
      var diff = e.changedTouches[0].clientX - startX;
      var threshold = cardMedia.offsetWidth * 0.2;

      if (diff < -threshold && currentIndex < total - 1) {
        currentIndex++;
      } else if (diff > threshold && currentIndex > 0) {
        currentIndex--;
      }

      swiper.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      dots.querySelectorAll('.product-carousel__dot').forEach(function (dot, i) {
        dot.classList.toggle('product-carousel__dot--active', i === currentIndex);
      });
    });

    // Dot tap
    dots.querySelectorAll('.product-carousel__dot').forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        currentIndex = i;
        swiper.style.transition = 'transform 0.3s ease';
        swiper.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
        dots.querySelectorAll('.product-carousel__dot').forEach(function (d, j) {
          d.classList.toggle('product-carousel__dot--active', j === currentIndex);
        });
      });
    });
  });
};

// Late-init: the inline custom-element's connectedCallback may have fired
// before this deferred script defined initCarouselSwipers. Catch any
// carousel containers that were mounted but skipped.
(function () {
  function bootstrap() {
    document.querySelectorAll('product-carousel-swiper, product-carousel-recently-viewed, product-carousel-you-may-also-love, product-carousel-more-from-collection').forEach(function (el) {
      window.initCarouselSwipers(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-run when crossing the mobile breakpoint (covers theme editor viewport toggle)
  var mq = window.matchMedia('(max-width: 749px)');
  var onChange = function (e) { if (e.matches) bootstrap(); };
  if (mq.addEventListener) {
    mq.addEventListener('change', onChange);
  } else if (mq.addListener) {
    mq.addListener(onChange);
  }
})();

window.DeserveRecentlyViewed = {
  KEY: 'deserve:recently_viewed',
  MAX: 20,

  record: function (handle) {
    if (!handle) return;
    try {
      var items = JSON.parse(localStorage.getItem(this.KEY) || '[]');
      items = items.filter(function (h) { return h !== handle; });
      items.unshift(handle);
      if (items.length > this.MAX) items = items.slice(0, this.MAX);
      localStorage.setItem(this.KEY, JSON.stringify(items));
    } catch (e) { /* localStorage unavailable */ }
  },

  get: function (excludeHandle, limit) {
    try {
      var items = JSON.parse(localStorage.getItem(this.KEY) || '[]');
      if (excludeHandle) {
        items = items.filter(function (h) { return h !== excludeHandle; });
      }
      return items.slice(0, limit || 10);
    } catch (e) {
      return [];
    }
  }
};
